import * as tslib_1 from "tslib";
// Core packages
import { FormGroup } from "@angular/forms";
// Third party packages
// Custom packages
/**
 * Creates a forrmly field group by docuemnt type.title
 * Es. to doc type = AA1 get A4Schema formly field group
 *
 * @since 1.0.0
 */
var DocumentTypeStructure = /** @class */ (function () {
    function DocumentTypeStructure() {
        this.form = new FormGroup({});
        this.orderContracts = [
            "AG1",
            "IA16",
            "ND3",
            "NA3",
            "ND1",
            "NB3",
            "HA6",
            "HA7",
            "HA8",
            "AB6",
            "AG2",
            "AD2",
            "HA12",
            "HA64",
            "QC11",
            "QB11",
            "NE1",
            "LC1",
            "LB1",
            "LA5",
            "LA8",
            "LA40",
            "LG12",
            "LO38",
            "LH17",
            "LI8",
            "LL6",
            "MA8",
            "MA10",
            "MB8",
            "MB10",
            "IA6",
            "IB9",
            "IA10",
            "IB13",
            "IA13",
            "IB15",
            "IB6",
            "NB5",
            "QA1",
            "QB6",
            "QC7",
            "QD5",
            "RE4",
            "QE5",
            "QF5",
            "LM5",
            "AB2",
            "OE6",
            "LG4",
            "LG9",
            "RB5",
            "RI3",
            "ID7",
            "NC3",
            "HA44",
            "LI5",
            "IC5",
            "IE7",
            "HA48",
            "AB11",
            "OC5",
            "OD5",
            "OF5",
            "OE3",
            "TA8",
            "TA12",
            "OA5",
            "OB5",
            "LF5",
            "RL19",
            "RF4",
            "HA61",
            "RM5"
        ];
        this.dataType = {
            A3mSchema: {
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            A4PlusSchema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            A4Schema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            A5Schema: {
                nomeFornitore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "suppliersName",
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            A5mSchema: {
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataStipulaContratto",
                },
                dataPrimaScadenza: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataPrimaScadenza",
                },
                tempoDiPreavviso: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "0",
                            label: "properties.structures.types.disdetta0",
                        },
                        {
                            value: "30",
                            label: "properties.structures.types.disdetta30",
                        },
                        {
                            value: "60",
                            label: "properties.structures.types.disdetta60",
                        },
                        {
                            value: "90",
                            label: "properties.structures.types.disdetta90",
                        },
                        {
                            value: "120",
                            label: "properties.structures.types.disdetta120",
                        },
                        {
                            value: "150",
                            label: "properties.structures.types.disdetta150",
                        },
                        {
                            value: "180",
                            label: "properties.structures.types.disdetta180",
                        },
                        {
                            value: "365",
                            label: "properties.structures.types.disdetta365",
                        },
                        {
                            value: "730",
                            label: "properties.structures.types.disdetta730",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.disdetta15a",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.disdetta20a",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.disdetta25a",
                        },
                    ],
                },
                dataSecondaScadenza: {
                    type: "Date",
                    required: true,
                    label: "dataSecondaScadenza",
                },
                tempoPreavvisoDisdetta: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "0",
                            label: "properties.structures.types.disdetta0",
                        },
                        {
                            value: "30",
                            label: "properties.structures.types.disdetta30",
                        },
                        {
                            value: "60",
                            label: "properties.structures.types.disdetta60",
                        },
                        {
                            value: "90",
                            label: "properties.structures.types.disdetta90",
                        },
                        {
                            value: "120",
                            label: "properties.structures.types.disdetta120",
                        },
                        {
                            value: "150",
                            label: "properties.structures.types.disdetta150",
                        },
                        {
                            value: "180",
                            label: "properties.structures.types.disdetta180",
                        },
                        {
                            value: "365",
                            label: "properties.structures.types.disdetta365",
                        },
                        {
                            value: "730",
                            label: "properties.structures.types.disdetta730",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.disdetta15a",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.disdetta20a",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.disdetta25a",
                        },
                    ],
                },
                durataAPartireDallaSecondaScadenza: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "3m",
                            label: "properties.structures.types.mesi3",
                        },
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "9m",
                            label: "properties.structures.types.mesi9",
                        },
                        {
                            value: "0a",
                            label: "properties.structures.types.anni0",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.disdetta15a",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.disdetta20a",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.disdetta25a",
                        },
                    ],
                    expressionProperties: {
                        "templateOptions.onChange": function (model, formState, field) {
                            var ret = "";
                            if (typeof model.durataAPartireDallaSecondaScadenza !== "undefined" &&
                                model.durataAPartireDallaSecondaScadenza !== "" &&
                                model.durataAPartireDallaSecondaScadenza !== "0a" &&
                                model.tipoDiRinnovo !== "Rinnovo automatico") {
                                ret = "Rinnovo automatico";
                                field.form.controls["tipoDiRinnovo"].setValue(ret);
                            }
                            else if (typeof model.durataAPartireDallaSecondaScadenza !== "undefined" &&
                                model.durataAPartireDallaSecondaScadenza === "0a" &&
                                model.tipoDiRinnovo !== "Senza rinnovo automatico") {
                                ret = "Senza rinnovo automatico";
                                field.form.controls["tipoDiRinnovo"].setValue(ret);
                            }
                            else if (typeof model.durataAPartireDallaSecondaScadenza !== "undefined" &&
                                model.durataAPartireDallaSecondaScadenza === "" &&
                                model.tipoDiRinnovo !== "") {
                                ret = "";
                                field.form.controls["tipoDiRinnovo"].setValue(ret);
                            }
                        },
                    },
                },
                tipoDiRinnovo: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    readonly: true,
                },
                importo: {
                    type: "Number",
                    min: 0,
                    max: 99999999,
                    required: false,
                },
            },
            A7Schema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "data",
                },
                pagamento: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "unicaSoluzione",
                            label: "properties.detail.documentArchive.fields.pagamentoUnicaSoluzione",
                        },
                        {
                            value: "aRate",
                            label: "properties.detail.documentArchive.fields.pagamentoARate",
                        },
                    ],
                },
            },
            A8Schema: {
                rilasciatoFirmatoDa: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 500,
                    required: true,
                },
                numeroProtocollo: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 500,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            A8PlusSchema: {
                rilasciatoFirmatoDa: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 500,
                    required: true,
                },
                numeroProtocollo: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 500,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            A9Schema: {
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
                rilasciatoFirmatoDa: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                numeroProtocollo: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 500,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            ASchema: {
                nomeSocietaEroganteInServizio: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataStipulaContratto",
                },
                importo: {
                    type: "Number",
                    min: 0,
                    max: 99999999,
                    required: false,
                },
            },
            B2Schema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            B3Schema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
            },
            B5Schema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 0,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                prescrizioni: {
                    type: "Select",
                    enum: ["assenti", "presenti"],
                    maxlenght: 50,
                    required: true,
                    defaultValue: "assenti",
                    options: [
                        {
                            value: "assenti",
                            label: "properties.structures.types.assenti",
                        },
                        {
                            value: "presenti",
                            label: "properties.structures.types.presenti",
                        },
                    ],
                },
            },
            B6Schema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDellaVerifica",
                },
                durataDocumento: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                    ],
                },
            },
            B6StarSchema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDellaVerifica",
                },
                durataDocumento: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                    ],
                },
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
            },
            BBMinusSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "String",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            BBPlusSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "String",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            BBSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "String",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
            },
            BBSlashSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "String",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeFornitore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "suppliersName",
                },
            },
            BBStarSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "String",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
            },
            BMinusSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            BPlusSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            BSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            BSlashSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeFornitore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "suppliersName",
                },
            },
            BStarSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
            },
            BXSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDellaVerifica",
                },
                durataDocumento: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.anni15",
                        },
                        {
                            value: "30a",
                            label: "properties.structures.types.anni30",
                        },
                    ],
                },
            },
            DSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataStipula",
                },
                dataPrimaScadenza: {
                    type: "Date",
                    required: true,
                    label: "dataPrimaScadenza",
                },
                durataAPartireDallaPrimaScadenza: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "3m",
                            label: "properties.structures.types.mesi3",
                        },
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "9m",
                            label: "properties.structures.types.mesi9",
                        },
                        {
                            value: "0a",
                            label: "properties.structures.types.anni0",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.anni15",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.anni20",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.anni25",
                        },
                    ],
                    expressionProperties: {
                        "templateOptions.onChange": function (model, formState, field) {
                            if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza !== "" &&
                                model.durataAPartireDallaPrimaScadenza !== "0a" &&
                                model.tipoDiRinnovo !== "Rinnovo automatico") {
                                field.form.controls["tipoDiRinnovo"].setValue("Rinnovo automatico");
                            }
                            else if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza === "0a" &&
                                model.tipoDiRinnovo !== "Senza rinnovo automatico") {
                                field.form.controls["tipoDiRinnovo"].setValue("Senza rinnovo automatico");
                            }
                            else if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza === "" &&
                                model.tipoDiRinnovo !== "") {
                                field.form.controls["tipoDiRinnovo"].setValue("");
                            }
                        },
                    },
                },
                tipoDiRinnovo: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    readonly: true,
                },
                tempoPreavvisoDisdetta: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "0",
                            label: "properties.structures.types.disdetta0",
                        },
                        {
                            value: "30",
                            label: "properties.structures.types.disdetta30",
                        },
                        {
                            value: "60",
                            label: "properties.structures.types.disdetta60",
                        },
                        {
                            value: "90",
                            label: "properties.structures.types.disdetta90",
                        },
                        {
                            value: "120",
                            label: "properties.structures.types.disdetta120",
                        },
                        {
                            value: "150",
                            label: "properties.structures.types.disdetta150",
                        },
                        {
                            value: "180",
                            label: "properties.structures.types.disdetta180",
                        },
                        {
                            value: "365",
                            label: "properties.structures.types.disdetta365",
                        },
                        {
                            value: "730",
                            label: "properties.structures.types.disdetta730",
                        },
                        {
                            value: "5475",
                            label: "properties.structures.types.disdetta15a",
                        },
                        {
                            value: "7300",
                            label: "properties.structures.types.disdetta20a",
                        },
                        {
                            value: "9125",
                            label: "properties.structures.types.disdetta25a",
                        },
                    ],
                },
                periodicitaInterventi: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "1m",
                            label: "properties.structures.types.mesi1",
                        },
                        {
                            value: "2m",
                            label: "properties.structures.types.mesi2",
                        },
                        {
                            value: "3m",
                            label: "properties.structures.types.mesi3",
                        },
                        {
                            value: "4m",
                            label: "properties.structures.types.mesi4",
                        },
                        {
                            value: "5m",
                            label: "properties.structures.types.mesi5",
                        },
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                    ],
                },
                importo: {
                    type: "Number",
                    min: 0,
                    max: 99999999,
                    required: false,
                },
            },
            E1Schema: {
                tipologiaIntervento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
            },
            F1Schema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: false,
                    label: "dataDocumento",
                },
                meseDiRiferimento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 20,
                    required: true,
                },
            },
            F2Schema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataStipula",
                },
                dataPrimaScadenza: {
                    type: "Date",
                    required: true,
                    label: "dataPrimaScadenza",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
                durataAPartireDallaPrimaScadenza: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "3m",
                            label: "properties.structures.types.mesi3",
                        },
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "9m",
                            label: "properties.structures.types.mesi9",
                        },
                        {
                            value: "0a",
                            label: "properties.structures.types.anni0",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.anni15",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.anni20",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.anni25",
                        },
                    ],
                    expressionProperties: {
                        "templateOptions.onChange": function (model, formState, field) {
                            if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza !== "" &&
                                model.durataAPartireDallaPrimaScadenza !== "0a" &&
                                model.tipoDiRinnovo !== "Rinnovo automatico") {
                                field.form.controls["tipoDiRinnovo"].setValue("Rinnovo automatico");
                            }
                            else if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza === "0a" &&
                                model.tipoDiRinnovo !== "Senza rinnovo automatico") {
                                field.form.controls["tipoDiRinnovo"].setValue("Senza rinnovo automatico");
                            }
                            else if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza === "" &&
                                model.tipoDiRinnovo !== "") {
                                field.form.controls["tipoDiRinnovo"].setValue("");
                            }
                        },
                    },
                },
                tipoDiRinnovo: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    readonly: true,
                },
                tempoPreavvisoDisdetta: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "0",
                            label: "properties.structures.types.disdetta0",
                        },
                        {
                            value: "30",
                            label: "properties.structures.types.disdetta30",
                        },
                        {
                            value: "60",
                            label: "properties.structures.types.disdetta60",
                        },
                        {
                            value: "90",
                            label: "properties.structures.types.disdetta90",
                        },
                        {
                            value: "120",
                            label: "properties.structures.types.disdetta120",
                        },
                        {
                            value: "150",
                            label: "properties.structures.types.disdetta150",
                        },
                        {
                            value: "180",
                            label: "properties.structures.types.disdetta180",
                        },
                        {
                            value: "365",
                            label: "properties.structures.types.disdetta365",
                        },
                        {
                            value: "730",
                            label: "properties.structures.types.disdetta730",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.disdetta15a",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.disdetta20a",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.disdetta25a",
                        },
                    ],
                },
                importo: {
                    type: "Number",
                    min: 0,
                    max: 99999999,
                    required: false,
                },
            },
            FSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataStipula",
                },
                dataPrimaScadenza: {
                    type: "Date",
                    required: true,
                    label: "dataPrimaScadenza",
                },
                durataAPartireDallaPrimaScadenza: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "3m",
                            label: "properties.structures.types.mesi3",
                        },
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "9m",
                            label: "properties.structures.types.mesi9",
                        },
                        {
                            value: "0a",
                            label: "properties.structures.types.anni0",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.anni15",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.anni20",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.anni25",
                        },
                    ],
                    expressionProperties: {
                        "templateOptions.onChange": function (model, formState, field) {
                            var ret = "";
                            if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza !== "" &&
                                model.durataAPartireDallaPrimaScadenza !== "0a" &&
                                model.tipoDiRinnovo !== "Rinnovo automatico") {
                                ret = "Rinnovo automatico";
                                field.form.controls["tipoDiRinnovo"].setValue(ret);
                            }
                            else if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza === "0a" &&
                                model.tipoDiRinnovo !== "Senza rinnovo automatico") {
                                ret = "Senza rinnovo automatico";
                                field.form.controls["tipoDiRinnovo"].setValue(ret);
                            }
                            else if (typeof model.durataAPartireDallaPrimaScadenza !== "undefined" &&
                                model.durataAPartireDallaPrimaScadenza === "" &&
                                model.tipoDiRinnovo !== "") {
                                ret = "";
                                field.form.controls["tipoDiRinnovo"].setValue(ret);
                            }
                        },
                    },
                },
                tipoDiRinnovo: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    readonly: true,
                },
                tempoPreavvisoDisdetta: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "0",
                            label: "properties.structures.types.disdetta0",
                        },
                        {
                            value: "30",
                            label: "properties.structures.types.disdetta30",
                        },
                        {
                            value: "60",
                            label: "properties.structures.types.disdetta60",
                        },
                        {
                            value: "90",
                            label: "properties.structures.types.disdetta90",
                        },
                        {
                            value: "120",
                            label: "properties.structures.types.disdetta120",
                        },
                        {
                            value: "150",
                            label: "properties.structures.types.disdetta150",
                        },
                        {
                            value: "180",
                            label: "properties.structures.types.disdetta180",
                        },
                        {
                            value: "365",
                            label: "properties.structures.types.disdetta365",
                        },
                        {
                            value: "730",
                            label: "properties.structures.types.disdetta730",
                        },
                        {
                            value: "15a",
                            label: "properties.structures.types.disdetta15a",
                        },
                        {
                            value: "20a",
                            label: "properties.structures.types.disdetta20a",
                        },
                        {
                            value: "25a",
                            label: "properties.structures.types.disdetta25a",
                        },
                    ],
                },
                importo: {
                    type: "Number",
                    min: 0,
                    max: 99999999,
                    required: false,
                },
            },
            G1Schema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataRilascioDocumento",
                },
                tipoDurataPermessoDiSoggiorno: {
                    type: "Select",
                    enum: ["limitato", "illimitato"],
                    maxlenght: 50,
                    required: true,
                    defaultValue: "limitato",
                    options: [
                        {
                            value: "limitato",
                            label: "properties.structures.types.limitato",
                        },
                        {
                            value: "illimitato",
                            label: "properties.structures.types.illimitato",
                        },
                    ],
                },
                //(tendina: limitato/illimitato)
                //(se limitato: data scadenza)
                dataScadenza: {
                    type: "Date",
                    expressionProperties: {
                        "templateOptions.required": "model.tipoDurataPermessoDiSoggiorno ==='limitato'",
                    },
                    label: "dataScadenza",
                },
            },
            GMinusSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            GPlusSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            GSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
            },
            GSlashSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeFornitore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "suppliersName",
                },
            },
            GStarSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
            },
            H1Schema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: false,
                    label: "dataDocumento",
                },
                annoDiRiferimento: {
                    type: "Number",
                    required: true,
                },
                annoDiArchiviazione: {
                    type: "SelectNew",
                    required: true,
                    options: "yearsOfStorage",
                },
            },
            I1Schema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataRichiesta",
                },
                dataScadenzaAstensione: {
                    type: "Date",
                    required: true,
                    label: "dataScadenzaAstensione",
                },
            },
            L2Schema: {
                daNome: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                aNnome: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            LPlusSchema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: false,
                    label: "dataDocumento",
                },
                ragioneSocialeCostruttore: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 100,
                    required: true,
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            LSchema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: false,
                    label: "dataDocumento",
                },
                ragioneSocialeCostruttore: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 100,
                    required: true,
                },
            },
            RSchema: {
                riferimentoComuneASL: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                nomeIspettore: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
            },
            SSchema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: false,
                    label: "dataDocumento",
                },
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                nomeFirmatarioAutorizzatoDellaDittaInstallatrice: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                annoDiInstallazioneDellImpianto: {
                    type: "Number",
                    required: true,
                },
            },
            TSchema: {
                nomeAmministratoreDelCondominio: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                nomeFornitoreCombustibile: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
            },
            TXSchema: {
                nomeAmministratoreDelCondominio: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
                durataDocumento: {
                    type: "Select",
                    required: true,
                    options: [
                        {
                            value: "6m",
                            label: "properties.structures.types.mesi6",
                        },
                        {
                            value: "1a",
                            label: "properties.structures.types.anni1",
                        },
                        {
                            value: "2a",
                            label: "properties.structures.types.anni2",
                        },
                        {
                            value: "3a",
                            label: "properties.structures.types.anni3",
                        },
                        {
                            value: "4a",
                            label: "properties.structures.types.anni4",
                        },
                        {
                            value: "5a",
                            label: "properties.structures.types.anni5",
                        },
                        {
                            value: "6a",
                            label: "properties.structures.types.anni6",
                        },
                        {
                            value: "7a",
                            label: "properties.structures.types.anni7",
                        },
                        {
                            value: "8a",
                            label: "properties.structures.types.anni8",
                        },
                        {
                            value: "9a",
                            label: "properties.structures.types.anni9",
                        },
                        {
                            value: "10a",
                            label: "properties.structures.types.anni10",
                        },
                    ],
                },
            },
            WSchema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: false,
                    label: "dataDocumento",
                },
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                periodoDiRiferimentoDa: {
                    type: "Date",
                    required: true,
                    label: "periodoDiRiferimentoDa",
                },
                periodoDiRiferimentoA: {
                    type: "Date",
                    required: true,
                    label: "periodoDiRiferimentoA",
                },
            },
            WPlusSchema: {
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: false,
                    label: "dataDocumento",
                },
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                periodoDiRiferimentoDa: {
                    type: "Date",
                    required: true,
                    label: "periodoDiRiferimentoDa",
                },
                periodoDiRiferimentoA: {
                    type: "Date",
                    required: true,
                    label: "periodoDiRiferimentoA",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            XSchema: {
                nomeIdentificativoDellaReteDiTeleriscaldamento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataStipulaContratto",
                },
            },
            XX1MinusSchema: {
                nomeDiRiferimento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            XX1PlusSchema: {
                nomeDiRiferimento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            XX1Schema: {
                nomeDiRiferimento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            XX1SlashSchema: {
                nomeDiRiferimento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeFornitore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "suppliersName",
                },
            },
            XX1StarSchema: {
                nomeDiRiferimento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeConduttore: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "conductorName",
                },
            },
            YSchema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                nomeStudioProgettazione: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataEmissioneDocumento",
                },
            },
            Z1Schema: {
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
            },
            Z1PlusSchema: {
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            Z3Schema: {
                ragioneSocialeFornitore: {
                    type: "Hidden",
                    defaultValue: '',
                },
                ragioneSocialeFornitoreId: {
                    type: "Autocomplete-Supplier",
                    bindLabel: "companyName",
                    bindValue: "_id",
                    multiple: false,
                    search: "suppliersService",
                    required: true,
                },
                aFirmaDi: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
            Z4Schema: {
                titoloDocumento: {
                    type: "String",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                },
                dataDocumento: {
                    type: "DateNotAvailable",
                    required: true,
                    label: "dataDocumento",
                },
                nomeArchiviazioneIntervento: {
                    type: "SelectNew",
                    minlenght: 2,
                    maxlenght: 50,
                    required: true,
                    options: "nameInterventionArchiving",
                },
            },
        };
    }
    /**
     * Get formly field group by doc type
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.getFormlyFields2 = function (schemaType, disabled) {
        var aryFields = [];
        if (schemaType) {
            var structureType = this.dataType[schemaType];
            var _loop_1 = function (prop) {
                if (structureType[prop].type === "Autocomplete" ||
                    structureType[prop].type === "Autocomplete-Supplier") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        type: structureType[prop].type.toLowerCase(),
                        key: "" + prop,
                        expressionProperties: structureType[prop].expressionProperties
                            ? structureType[prop].expressionProperties
                            : "",
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            customLabel: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            placeholder: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                            disabled: disabled,
                            bindLabel: structureType[prop].bindLabel,
                            bindValue: structureType[prop].bindValue,
                            multiple: structureType[prop].multiple,
                            search$: structureType[prop].search,
                            addTag: function (term) {
                                return term.replace(/\./gi, "").toUpperCase();
                            },
                            addTagText: "common.words.addTag",
                        },
                    });
                }
                if (structureType[prop].type === "String") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        type: "input",
                        key: "" + prop,
                        expressionProperties: structureType[prop].expressionProperties
                            ? structureType[prop].expressionProperties
                            : "",
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            label: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            placeholder: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                            minLength: structureType[prop].minLength,
                            maxLength: structureType[prop].maxLength,
                            disabled: disabled,
                        },
                    });
                }
                if (structureType[prop].type === "Textarea") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        type: "textarea",
                        key: "" + prop,
                        expressionProperties: structureType[prop].expressionProperties
                            ? structureType[prop].expressionProperties
                            : "",
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            label: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            placeholder: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                            minLength: structureType[prop].minLength,
                            maxLength: structureType[prop].maxLength,
                            disabled: disabled,
                            rows: structureType[prop].rows,
                        },
                    });
                }
                if (structureType[prop].type === "Date") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        type: "datepicker",
                        key: "" + prop,
                        expressionProperties: structureType[prop].expressionProperties
                            ? structureType[prop].expressionProperties
                            : "",
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            label: "properties.detail.documentArchive.fields." + structureType[prop].label,
                            placeholder: "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                            disabled: disabled,
                        },
                    });
                }
                if (structureType[prop].type === "DateNotAvailable") {
                    aryFields.push({
                        className: "col-8 col-md-8 col-xl-8",
                        type: "datepicker",
                        key: "" + prop,
                        expressionProperties: {
                            "templateOptions.required": function (model) {
                                var currentValue = model[prop + "chkNA"];
                                return !currentValue;
                            },
                            "templateOptions.disabled": function (model) {
                                var currentValue = model[prop + "chkNA"];
                                return currentValue;
                            }
                        },
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            label: "properties.detail.documentArchive.fields." + structureType[prop].label,
                            placeholder: "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                        },
                    });
                    aryFields.push({
                        className: "col-4 col-md-4 col-xl-4",
                        type: "checkbox",
                        key: prop + "chkNA",
                        defaultValue: false,
                        templateOptions: {
                            readonly: false,
                            label: "properties.detail.documentArchive.notAvailable",
                            placeholder: "properties.detail.documentArchive.notAvailable",
                            required: false,
                            disabled: false,
                        },
                    });
                }
                if (structureType[prop].type === "Number") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        type: "input",
                        key: "" + prop,
                        hide: structureType[prop].hide ? structureType[prop].hide : false,
                        defaultValue: structureType[prop].defaultValue
                            ? structureType[prop].defaultValue
                            : structureType[prop].min
                                ? structureType[prop].min
                                : 0,
                        expressionProperties: structureType[prop].expressionProperties
                            ? structureType[prop].expressionProperties
                            : "",
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            label: "properties.detail.documentArchive.fields." + prop,
                            placeholder: "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                            type: "number",
                            step: 1,
                            min: structureType[prop].min ? structureType[prop].min : 0,
                            max: structureType[prop].max ? structureType[prop].max : 99999,
                            disabled: disabled,
                        },
                    });
                }
                if (structureType[prop].type === "Select") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        type: "select",
                        key: "" + prop,
                        expressionProperties: structureType[prop].expressionProperties
                            ? structureType[prop].expressionProperties
                            : "",
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            label: "properties.detail.documentArchive.fields." + prop,
                            placeholder: "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                            disabled: disabled,
                            options: structureType[prop].options,
                        },
                    });
                }
                if (structureType[prop].type === "Hidden") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        key: "" + prop,
                        defaultValue: structureType[prop].defaultValue
                            ? structureType[prop].defaultValue
                            : "",
                    });
                }
                if (structureType[prop].type === "SelectNew") {
                    aryFields.push({
                        className: "col-12 col-md-12 col-xl-12",
                        type: "selectNew",
                        key: "" + prop,
                        expressionProperties: structureType[prop].expressionProperties
                            ? structureType[prop].expressionProperties
                            : "",
                        templateOptions: {
                            readonly: structureType[prop].readonly
                                ? structureType[prop].readonly
                                : false,
                            customLabel: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            placeholder: structureType[prop].label
                                ? "properties.detail.documentArchive.fields." + structureType[prop].label
                                : "properties.detail.documentArchive.fields." + prop,
                            required: structureType[prop].required,
                            disabled: disabled,
                            // bindLabel: structureType[prop].bindLabel,
                            // bindValue: structureType[prop].bindValue,
                            multiple: structureType[prop].multiple
                                ? structureType[prop].multiple
                                : false,
                            // search$: structureType[prop].search,
                            initialValues: structureType[prop].options,
                            addTag: function (term) {
                                return term.replace(/\./gi, "").toUpperCase();
                            },
                            addTagText: "common.words.addTag",
                        },
                    });
                }
            };
            for (var prop in structureType) {
                _loop_1(prop);
            }
            return aryFields;
        }
        return "";
    };
    /**
     * Get document route by doc type
     * docType: es. AC2
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.getDocRoute2 = function (key, documentTemplate) {
        var e_1, _a, e_2, _b, e_3, _c;
        var route = "";
        var found = false;
        if (documentTemplate && Array.isArray(documentTemplate)) {
            try {
                for (var documentTemplate_1 = tslib_1.__values(documentTemplate), documentTemplate_1_1 = documentTemplate_1.next(); !documentTemplate_1_1.done; documentTemplate_1_1 = documentTemplate_1.next()) {
                    var docs = documentTemplate_1_1.value;
                    var content = docs.content;
                    if (content && Array.isArray(content)) {
                        try {
                            for (var content_1 = (e_2 = void 0, tslib_1.__values(content)), content_1_1 = content_1.next(); !content_1_1.done; content_1_1 = content_1.next()) {
                                var subDocs = content_1_1.value;
                                var documents = subDocs.documents;
                                if (documents && Array.isArray(documents)) {
                                    try {
                                        for (var documents_1 = (e_3 = void 0, tslib_1.__values(documents)), documents_1_1 = documents_1.next(); !documents_1_1.done; documents_1_1 = documents_1.next()) {
                                            var doc = documents_1_1.value;
                                            if (doc.key && doc.key === key) {
                                                route = subDocs.title.replace("properties.documents.", "");
                                                found = true;
                                                break;
                                            }
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (documents_1_1 && !documents_1_1.done && (_c = documents_1.return)) _c.call(documents_1);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                }
                                if (found) {
                                    break;
                                }
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (content_1_1 && !content_1_1.done && (_b = content_1.return)) _b.call(content_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                    }
                    if (found) {
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (documentTemplate_1_1 && !documentTemplate_1_1.done && (_a = documentTemplate_1.return)) _a.call(documentTemplate_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return route;
    };
    /**
     * Get area from child code (es: properties.structures.gestAmmTivoGestionali, ...)
     */
    DocumentTypeStructure.prototype.getAreaFromChild2 = function (child, documentTemplate) {
        var e_4, _a, e_5, _b;
        var code = 0;
        var group = "";
        var found = false;
        if (documentTemplate && Array.isArray(documentTemplate)) {
            try {
                for (var documentTemplate_2 = tslib_1.__values(documentTemplate), documentTemplate_2_1 = documentTemplate_2.next(); !documentTemplate_2_1.done; documentTemplate_2_1 = documentTemplate_2.next()) {
                    var docs = documentTemplate_2_1.value;
                    var content = docs.content;
                    if (content && Array.isArray(content)) {
                        try {
                            for (var content_2 = (e_5 = void 0, tslib_1.__values(content)), content_2_1 = content_2.next(); !content_2_1.done; content_2_1 = content_2.next()) {
                                var subDocs = content_2_1.value;
                                if (subDocs.title === child) {
                                    group = docs.group;
                                    found = true;
                                    break;
                                }
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (content_2_1 && !content_2_1.done && (_b = content_2.return)) _b.call(content_2);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                    }
                    if (found) {
                        break;
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (documentTemplate_2_1 && !documentTemplate_2_1.done && (_a = documentTemplate_2.return)) _a.call(documentTemplate_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        switch (group) {
            case "amministrativo":
                code = 1;
                break;
            case "contratti":
                code = 2;
                break;
            case "tecnico":
                code = 3;
                break;
            case "unitaImmobiliari":
                code = 4;
                break;
        }
        return code;
    };
    /**
     * Get topics of docs area from code (es: 1, 2...)
     */
    DocumentTypeStructure.prototype.getDocumentArea2 = function (code, documentTemplate) {
        if (typeof code === "undefined" || code === undefined) {
            return {};
        }
        var codeArea = "";
        switch (code) {
            case "1":
                codeArea = "amministrativo";
                break;
            case "2":
                codeArea = "contratti";
                break;
            case "3":
                codeArea = "tecnico";
                break;
            case "4":
                codeArea = "unitaImmobiliari";
                break;
        }
        var subArea = documentTemplate.filter(function (elem) {
            return elem.group === codeArea;
        });
        if (subArea) {
            return {
                code: code,
                content: subArea,
                title: codeArea,
            };
        }
        else {
            return {};
        }
    };
    /**
     * Get subdocs from subarea
     */
    DocumentTypeStructure.prototype.getSubDocsArea2 = function (subarea, documentTemplate, subscriptionFree) {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d;
        if (subscriptionFree === void 0) { subscriptionFree = false; }
        var element;
        var found = false;
        var contratti = false;
        var _loop_2 = function (item) {
            // documentTemplate.forEach((item: any) => {
            if (item.title == "properties.documents." + subarea &&
                subarea !== 'stackingPlan' &&
                subarea !== 'reportistica' &&
                subarea !== 'locazioneContrdiLocazione' &&
                subarea !== 'lineaVita' &&
                subarea !== 'amiantoDoc' &&
                subarea !== 'impiantiSpeciali') {
                if (subarea === "contratti" && item.content && Array.isArray(item.content)) {
                    contratti = true;
                    item.content.forEach(function (subItem) {
                        var e_10, _a;
                        if (subItem.title == "properties.documents." + subarea) {
                            if (subItem.documents && Array.isArray(subItem.documents)) {
                                try {
                                    for (var _b = (e_10 = void 0, tslib_1.__values(subItem.documents)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                        var subDoc = _c.value;
                                        subDoc.visible = true;
                                        subDoc.value = false;
                                        if (subDoc.key === "HA12") {
                                            subDoc.origin = "impelegenerale-contratti";
                                            subDoc.structure = "fornituraBt";
                                        }
                                        else if (subDoc.key === "HA64") {
                                            subDoc.origin = "impeleMediaTensione-contratti";
                                            subDoc.structure = "fornituraMt";
                                        }
                                    }
                                }
                                catch (e_10_1) { e_10 = { error: e_10_1 }; }
                                finally {
                                    try {
                                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                    }
                                    finally { if (e_10) throw e_10.error; }
                                }
                            }
                            element = subItem;
                        }
                    });
                    return "break";
                }
                else if (subarea === "unitaImmobiliari" && item.content && Array.isArray(item.content)) {
                    var docs_1 = [];
                    var title_1 = {};
                    item.content.forEach(function (subItem) {
                        var parentTitle = subItem.title.replace("properties.documents.", "");
                        if (subItem.documents && Array.isArray(subItem.documents)) {
                            subItem.documents.forEach(function (elDocs) { return elDocs.parentTitle = parentTitle; });
                        }
                        title_1 = subItem.translation;
                        docs_1 = tslib_1.__spread(docs_1, [title_1], subItem.documents);
                    });
                    element = item;
                    element.documents = docs_1;
                }
                else {
                    element = item;
                    return "break";
                }
            }
            else if (item.content && Array.isArray(item.content)) {
                item.content.forEach(function (subItem) {
                    if (subItem.title == "properties.documents." + subarea) {
                        element = subItem;
                        found = true;
                    }
                });
                if (found) {
                    return "break";
                }
            }
        };
        try {
            for (var documentTemplate_3 = tslib_1.__values(documentTemplate), documentTemplate_3_1 = documentTemplate_3.next(); !documentTemplate_3_1.done; documentTemplate_3_1 = documentTemplate_3.next()) {
                var item = documentTemplate_3_1.value;
                var state_1 = _loop_2(item);
                if (state_1 === "break")
                    break;
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (documentTemplate_3_1 && !documentTemplate_3_1.done && (_a = documentTemplate_3.return)) _a.call(documentTemplate_3);
            }
            finally { if (e_6) throw e_6.error; }
        }
        if (contratti) {
            var contracts = [];
            var structure = "";
            try {
                // Add contracts from other document types
                for (var documentTemplate_4 = tslib_1.__values(documentTemplate), documentTemplate_4_1 = documentTemplate_4.next(); !documentTemplate_4_1.done; documentTemplate_4_1 = documentTemplate_4.next()) {
                    var docs = documentTemplate_4_1.value;
                    if (docs.content &&
                        Array.isArray(docs.content) &&
                        docs.code !== "H" &&
                        !(subscriptionFree && docs.code === "U")) {
                        try {
                            for (var _e = (e_8 = void 0, tslib_1.__values(docs.content)), _f = _e.next(); !_f.done; _f = _e.next()) {
                                var subDocs = _f.value;
                                var documents = subDocs.documents;
                                if (subDocs.structure !== "") {
                                    structure = subDocs.structure;
                                }
                                else {
                                    structure = "";
                                }
                                var origin_1 = subDocs.title.replace("properties.documents.", "");
                                if (documents && Array.isArray(documents)) {
                                    try {
                                        for (var documents_2 = (e_9 = void 0, tslib_1.__values(documents)), documents_2_1 = documents_2.next(); !documents_2_1.done; documents_2_1 = documents_2.next()) {
                                            var doc = documents_2_1.value;
                                            if (doc.contract) {
                                                contracts.push({
                                                    _id: doc._id,
                                                    contract: doc.contract,
                                                    deleted: doc.deleted,
                                                    expirationNotice: doc.expirationNotice,
                                                    key: doc.key,
                                                    mandatory: doc.mandatory,
                                                    schemaType: doc.schemaType,
                                                    translation: doc.translation,
                                                    origin: origin_1,
                                                    structure: structure,
                                                    value: false,
                                                    visible: true,
                                                });
                                            }
                                        }
                                    }
                                    catch (e_9_1) { e_9 = { error: e_9_1 }; }
                                    finally {
                                        try {
                                            if (documents_2_1 && !documents_2_1.done && (_d = documents_2.return)) _d.call(documents_2);
                                        }
                                        finally { if (e_9) throw e_9.error; }
                                    }
                                }
                            }
                        }
                        catch (e_8_1) { e_8 = { error: e_8_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                            }
                            finally { if (e_8) throw e_8.error; }
                        }
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (documentTemplate_4_1 && !documentTemplate_4_1.done && (_b = documentTemplate_4.return)) _b.call(documentTemplate_4);
                }
                finally { if (e_7) throw e_7.error; }
            }
            if (element.documents && Array.isArray(element.documents) && contracts && Array.isArray(contracts)) {
                contracts.forEach(function (elConttract) {
                    element.documents.push({
                        _id: elConttract._id,
                        contract: elConttract.contract,
                        deleted: elConttract.deleted,
                        expirationNotice: elConttract.expirationNotice,
                        key: elConttract.key,
                        mandatory: elConttract.mandatory,
                        schemaType: elConttract.schemaType,
                        translation: elConttract.translation,
                        origin: elConttract.origin,
                        structure: elConttract.structure,
                        value: elConttract.value,
                        visible: elConttract.visible,
                    });
                });
                if (this.orderContracts && Array.isArray(this.orderContracts)) {
                    this.orderContracts.forEach(function (orderEl, orderIndex) {
                        var fromIndex = element.documents.findIndex(function (el) {
                            return el.key === orderEl;
                        });
                        if (fromIndex > -1) {
                            var contractElement = element.documents[fromIndex];
                            element.documents.splice(fromIndex, 1);
                            element.documents.splice(orderIndex, 0, contractElement);
                        }
                    });
                }
            }
            // End - Add contracts from other document types
        }
        return element;
    };
    /**
     * Get type of doc from code
     */
    DocumentTypeStructure.prototype.getDocumentType2 = function (code, documentTemplate) {
        var e_11, _a, e_12, _b, e_13, _c;
        var schemaType = "";
        var found = false;
        if (documentTemplate && Array.isArray(documentTemplate)) {
            try {
                for (var documentTemplate_5 = tslib_1.__values(documentTemplate), documentTemplate_5_1 = documentTemplate_5.next(); !documentTemplate_5_1.done; documentTemplate_5_1 = documentTemplate_5.next()) {
                    var docs = documentTemplate_5_1.value;
                    var content = docs.content;
                    if (content && Array.isArray(content)) {
                        try {
                            for (var content_3 = (e_12 = void 0, tslib_1.__values(content)), content_3_1 = content_3.next(); !content_3_1.done; content_3_1 = content_3.next()) {
                                var subDocs = content_3_1.value;
                                var documents = subDocs.documents;
                                if (documents && Array.isArray(documents)) {
                                    try {
                                        for (var documents_3 = (e_13 = void 0, tslib_1.__values(documents)), documents_3_1 = documents_3.next(); !documents_3_1.done; documents_3_1 = documents_3.next()) {
                                            var doc = documents_3_1.value;
                                            if (doc.key && doc.key === code) {
                                                schemaType = doc.schemaType;
                                                found = true;
                                                break;
                                            }
                                        }
                                    }
                                    catch (e_13_1) { e_13 = { error: e_13_1 }; }
                                    finally {
                                        try {
                                            if (documents_3_1 && !documents_3_1.done && (_c = documents_3.return)) _c.call(documents_3);
                                        }
                                        finally { if (e_13) throw e_13.error; }
                                    }
                                }
                                if (found) {
                                    break;
                                }
                            }
                        }
                        catch (e_12_1) { e_12 = { error: e_12_1 }; }
                        finally {
                            try {
                                if (content_3_1 && !content_3_1.done && (_b = content_3.return)) _b.call(content_3);
                            }
                            finally { if (e_12) throw e_12.error; }
                        }
                    }
                    if (found) {
                        break;
                    }
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (documentTemplate_5_1 && !documentTemplate_5_1.done && (_a = documentTemplate_5.return)) _a.call(documentTemplate_5);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
        return schemaType;
    };
    /**
     * Get topics of docs area from code (es: A, B...)
     */
    DocumentTypeStructure.prototype.getDocumentTopic2 = function (code, documentTemplate, structure) {
        var topic;
        var structureSubCodeToFilter = [];
        if (documentTemplate) {
            topic = documentTemplate.filter(function (arg) { return arg.code === code; })[0];
            if (structure) {
                if (topic.content && Array.isArray(topic.content)) {
                    topic.content.forEach(function (el) {
                        if (el.structure && el.structure !== "") {
                            if (!structure[el.structure].length ||
                                (structure[el.structure].length &&
                                    !structure[el.structure].some(function (prop) { return prop.active; }))) {
                                if (el.code === "AA") { // Gestionale Dipendenti
                                    structureSubCodeToFilter.push("AB");
                                }
                                structureSubCodeToFilter.push(el.code);
                            }
                        }
                        if (el.code === "IA") {
                            // Impianto elettrico generale
                            if (!structure["fornituraBt"].length ||
                                (structure["fornituraBt"].length &&
                                    !structure["fornituraBt"].some(function (prop) { return prop.active; }))) {
                                structureSubCodeToFilter.push(el.code);
                            }
                        }
                        if (el.code === "IB") {
                            // Impanto elettrico di Media Tensione
                            if (!structure["fornituraMt"].length ||
                                (structure["fornituraMt"].length &&
                                    !structure["fornituraMt"].some(function (prop) { return prop.active; }))) {
                                structureSubCodeToFilter.push(el.code);
                            }
                        }
                        if (el.code === "QG") {
                            // Impanto EVAC
                            if (!structure["evac"].length ||
                                (structure["evac"].length &&
                                    !structure["evac"].some(function (prop) { return prop.active; }))) {
                                structureSubCodeToFilter.push(el.code);
                            }
                        }
                    });
                }
            }
        }
        var content = [];
        topic.content.forEach(function (element) {
            var title = element.title;
            var rawTitle = title.split(".documents.", 2)[1];
            // A section hidden from the settings ("nascosto") is offered neither for new
            // documents nor as a search filter, as already happens for its documents.
            if (element.deleted !== true && !structureSubCodeToFilter.includes(element.code.toString())) {
                content.push({
                    type: "doc",
                    class: "doc",
                    visible: true,
                    code: element.code,
                    title: title,
                    translation: element.translation,
                    rawTitle: rawTitle,
                    parent: topic.code,
                    value: false,
                });
            }
        });
        return content;
    };
    /**
     * Get topics of docs area from key (es: AA, AB...)
     */
    DocumentTypeStructure.prototype.getDocumentSubTopic2 = function (code, parent, documentTemplate, structure, subscriptionFree, lang) {
        var e_14, _a, e_15, _b, e_16, _c;
        if (subscriptionFree === void 0) { subscriptionFree = false; }
        if (lang === void 0) { lang = "it"; }
        var content = [];
        var subAreaTitle = "";
        if (documentTemplate) {
            var topic = documentTemplate.filter(function (arg) { return arg.code === parent; })[0];
            var subTopic_1 = topic.content.find(function (el) {
                return el.code === code;
            });
            if (subTopic_1 && subTopic_1.translation) {
                subAreaTitle = subTopic_1.translation[lang];
            }
            // Contratti
            if (code === "HA" && parent == "H") {
                subTopic_1.documents.forEach(function (element) {
                    var title = element.translation.it;
                    var rawTitle = title.split(".documents.", 2)[1];
                    var origin = element.origin ? element.origin : "";
                    var loadDoc = true;
                    // Impianto elettrico generale
                    if (element.key === "HA12") {
                        origin = "impelegenerale-contratti";
                        if (structure &&
                            (!structure["fornituraBt"].length ||
                                (structure["fornituraBt"].length &&
                                    !structure["fornituraBt"].some(function (prop) { return prop.active; })))) {
                            loadDoc = false;
                        }
                    }
                    // Impianto elettrico media tensione
                    if (element.key === "HA64") {
                        origin = "impeleMediaTensione-contratti";
                        if (structure &&
                            (!structure["fornituraMt"].length ||
                                (structure["fornituraMt"].length &&
                                    !structure["fornituraMt"].some(function (prop) { return prop.active; })))) {
                            loadDoc = false;
                        }
                    }
                    if (loadDoc) {
                        content.push({
                            origin: origin,
                            type: "doc",
                            class: "doc",
                            visible: true,
                            code: element.key,
                            title: element.translation.it,
                            translation: element.translation,
                            rawTitle: rawTitle,
                            parent: subTopic_1.code,
                            value: false,
                            schemaType: element.schemaType,
                            deleted: element.deleted,
                            subAreaTitle: subAreaTitle,
                            mandatory: element.mandatory,
                            privacy: element.privacy
                        });
                    }
                });
                try {
                    // FREE: hide Unità Immobiliari contracts
                    for (var documentTemplate_6 = tslib_1.__values(documentTemplate), documentTemplate_6_1 = documentTemplate_6.next(); !documentTemplate_6_1.done; documentTemplate_6_1 = documentTemplate_6.next()) {
                        var docs = documentTemplate_6_1.value;
                        if (docs.code !== "H" &&
                            !(subscriptionFree && docs.code === "U")) {
                            if (docs.content && Array.isArray(docs.content)) {
                                try {
                                    for (var _d = (e_15 = void 0, tslib_1.__values(docs.content)), _e = _d.next(); !_e.done; _e = _d.next()) {
                                        var subDocs = _e.value;
                                        var origin_2 = subDocs.title.replace("properties.documents.", "");
                                        var documents = subDocs.documents;
                                        if (structure && subDocs.structure && subDocs.structure !== "") {
                                            if (!structure[subDocs.structure].length ||
                                                (structure[subDocs.structure].length &&
                                                    !structure[subDocs.structure].some(function (prop) { return prop.active; }))) {
                                                continue;
                                            }
                                        }
                                        if (documents && Array.isArray(documents)) {
                                            try {
                                                for (var documents_4 = (e_16 = void 0, tslib_1.__values(documents)), documents_4_1 = documents_4.next(); !documents_4_1.done; documents_4_1 = documents_4.next()) {
                                                    var doc = documents_4_1.value;
                                                    if (doc.contract) {
                                                        if (doc.key &&
                                                            ((doc.key.substring(0, 2) !== 'IA' &&
                                                                doc.key.substring(0, 2) !== 'IB') ||
                                                                (doc.key.substring(0, 2) === 'IA' &&
                                                                    (
                                                                    // No property structure (e.g. multi-property search): do not filter
                                                                    !structure ||
                                                                        structure["fornituraBt"] &&
                                                                            structure["fornituraBt"].length &&
                                                                            structure["fornituraBt"].some(function (prop) { return prop.active; }))) ||
                                                                (doc.key.substring(0, 2) === 'IB' &&
                                                                    (
                                                                    // No property structure (e.g. multi-property search): do not filter
                                                                    !structure ||
                                                                        structure["fornituraMt"] &&
                                                                            structure["fornituraMt"].length &&
                                                                            structure["fornituraMt"].some(function (prop) { return prop.active; }))))) {
                                                            var title = doc.translation.it;
                                                            var rawTitle = title.split(".documents.", 2)[1];
                                                            content.push({
                                                                origin: origin_2 ? origin_2 : "",
                                                                type: "doc",
                                                                class: "doc",
                                                                visible: true,
                                                                code: doc.key,
                                                                title: doc.translation.it,
                                                                translation: doc.translation,
                                                                rawTitle: rawTitle,
                                                                parent: subTopic_1.code,
                                                                value: false,
                                                                schemaType: doc.schemaType,
                                                                deleted: doc.deleted,
                                                                subAreaTitle: subAreaTitle,
                                                                mandatory: doc.mandatory,
                                                                privacy: doc.privacy
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                            catch (e_16_1) { e_16 = { error: e_16_1 }; }
                                            finally {
                                                try {
                                                    if (documents_4_1 && !documents_4_1.done && (_c = documents_4.return)) _c.call(documents_4);
                                                }
                                                finally { if (e_16) throw e_16.error; }
                                            }
                                        }
                                    }
                                }
                                catch (e_15_1) { e_15 = { error: e_15_1 }; }
                                finally {
                                    try {
                                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                                    }
                                    finally { if (e_15) throw e_15.error; }
                                }
                            }
                        }
                    }
                }
                catch (e_14_1) { e_14 = { error: e_14_1 }; }
                finally {
                    try {
                        if (documentTemplate_6_1 && !documentTemplate_6_1.done && (_a = documentTemplate_6.return)) _a.call(documentTemplate_6);
                    }
                    finally { if (e_14) throw e_14.error; }
                }
                if (this.orderContracts && Array.isArray(this.orderContracts)) {
                    this.orderContracts.forEach(function (orderEl, orderIndex) {
                        var fromIndex = content.findIndex(function (el) {
                            return el.code === orderEl;
                        });
                        if (fromIndex > -1) {
                            var contractElement = content[fromIndex];
                            content.splice(fromIndex, 1);
                            content.splice(orderIndex, 0, contractElement);
                        }
                    });
                }
            }
            else {
                subTopic_1.documents.forEach(function (element) {
                    var title = element.translation.it;
                    var rawTitle = title.split(".documents.", 2)[1];
                    if (!element.deleted) {
                        content.push({
                            origin: element.origin ? element.origin : "",
                            type: "doc",
                            class: "doc",
                            visible: true,
                            code: element.key,
                            title: element.translation.it,
                            translation: element.translation,
                            rawTitle: rawTitle,
                            parent: subTopic_1.code,
                            value: false,
                            schemaType: element.schemaType,
                            deleted: element.deleted,
                            subAreaTitle: subAreaTitle,
                            mandatory: element.mandatory,
                            privacy: element.privacy
                        });
                    }
                });
            }
        }
        return content;
    };
    DocumentTypeStructure.prototype.isContract2 = function (code, documentTemplate) {
        var e_17, _a, e_18, _b, e_19, _c;
        var contract = false;
        var found = false;
        if (documentTemplate && Array.isArray(documentTemplate)) {
            try {
                for (var documentTemplate_7 = tslib_1.__values(documentTemplate), documentTemplate_7_1 = documentTemplate_7.next(); !documentTemplate_7_1.done; documentTemplate_7_1 = documentTemplate_7.next()) {
                    var docs = documentTemplate_7_1.value;
                    var content = docs.content;
                    if (content && Array.isArray(content)) {
                        try {
                            for (var content_4 = (e_18 = void 0, tslib_1.__values(content)), content_4_1 = content_4.next(); !content_4_1.done; content_4_1 = content_4.next()) {
                                var subDocs = content_4_1.value;
                                var documents = subDocs.documents;
                                if (documents && Array.isArray(documents)) {
                                    try {
                                        for (var documents_5 = (e_19 = void 0, tslib_1.__values(documents)), documents_5_1 = documents_5.next(); !documents_5_1.done; documents_5_1 = documents_5.next()) {
                                            var doc = documents_5_1.value;
                                            if (doc.key && doc.key === code) {
                                                contract = doc.contract;
                                                found = true;
                                                break;
                                            }
                                        }
                                    }
                                    catch (e_19_1) { e_19 = { error: e_19_1 }; }
                                    finally {
                                        try {
                                            if (documents_5_1 && !documents_5_1.done && (_c = documents_5.return)) _c.call(documents_5);
                                        }
                                        finally { if (e_19) throw e_19.error; }
                                    }
                                }
                                if (found) {
                                    break;
                                }
                            }
                        }
                        catch (e_18_1) { e_18 = { error: e_18_1 }; }
                        finally {
                            try {
                                if (content_4_1 && !content_4_1.done && (_b = content_4.return)) _b.call(content_4);
                            }
                            finally { if (e_18) throw e_18.error; }
                        }
                    }
                    if (found) {
                        break;
                    }
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (documentTemplate_7_1 && !documentTemplate_7_1.done && (_a = documentTemplate_7.return)) _a.call(documentTemplate_7);
                }
                finally { if (e_17) throw e_17.error; }
            }
        }
        return contract;
    };
    /**
     * Order docs by expired property
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.compareExpired = function (a, b) {
        if (a.expired < b.expired) {
            return -1;
        }
        else if (a.expired > b.expired) {
            return 1;
        }
        else {
            return 0;
        }
    };
    /**
     * Utility: extracts documents from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.getDocsFromSection = function (section, lang, docsTemplate, subscriptionType, insertedDocs, structureDocDeleted) {
        if (structureDocDeleted === void 0) { structureDocDeleted = false; }
        var docList = [];
        var _loop_3 = function (doc) {
            var templateDoc = docsTemplate.find(function (el) {
                return el.key === doc;
            });
            if (section.documents[doc].length && templateDoc && !templateDoc.deleted) {
                section.documents[doc].forEach(function (item) {
                    if (!item.deleted || structureDocDeleted) {
                        if (item.data &&
                            item.data.nomeSocietaEroganteInServizio &&
                            // (item.data.rilasciatoFirmatoDa ||
                            //   item.data.nomeDiRiferimento ||
                            //   item.data.nomeSocietaEroganteInServizio ||
                            //   item.data.nomeConduttore ||
                            //   item.data.ragioneSocialeCostruttore ||
                            //   item.data.daNome ||
                            //   item.data.riferimentoComuneASL ||
                            //   item.data.nomeAmministratoreDelCondominio ||
                            //   item.data.nomeIdentificativoDellaReteDiTeleriscaldamento ||
                            //   item.data.aFirmaDi ||
                            //   item.data.nomeFornitore) &&
                            typeof item.data.ragioneSocialeFornitore === "undefined") {
                            if (item.data.rilasciatoFirmatoDa) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.rilasciatoFirmatoDa;
                            }
                            else if (item.data.nomeDiRiferimento) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeDiRiferimento;
                            }
                            else if (item.data.nomeConduttore) {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeConduttore;
                            }
                            else if (item.data.ragioneSocialeCostruttore) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.ragioneSocialeCostruttore;
                            }
                            else if (item.data.daNome) {
                                item.data["ragioneSocialeFornitore"] = item.data.daNome;
                            }
                            else if (item.data.riferimentoComuneASL) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.riferimentoComuneASL;
                            }
                            else if (item.data.nomeAmministratoreDelCondominio) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeAmministratoreDelCondominio;
                            }
                            else if (item.data.nomeIdentificativoDellaReteDiTeleriscaldamento) {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
                            }
                            else if (item.data.aFirmaDi) {
                                item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
                            }
                            else if (item.data.nomeFornitore) {
                                item.data["ragioneSocialeFornitore"] = item.data.nomeFornitore;
                            }
                            else {
                                item.data["ragioneSocialeFornitore"] =
                                    item.data.nomeSocietaEroganteInServizio;
                            }
                        }
                        if (item.data && item.data.barCode) {
                            if (item.data.barCode.length > 6) {
                                var docType = item.data.barCode.slice(-1);
                                var docCode = item.data.barCode.substring(item.data.barCode.length - 7, item.data.barCode.length - 1);
                                item.data["docCode"] = docCode + " " + docType;
                            }
                        }
                        if (item.data && item.cancellationRequestBy) {
                            item.data.cancellationRequestBy = item.cancellationRequestBy;
                            item.data.cancellationRequestDate = item.cancellationRequestDate;
                        }
                        docList.push({
                            title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                            type: "doc",
                            docId: item._id,
                            key: doc,
                            mandatory: (subscriptionType === "FREE" || subscriptionType === "FREEBASIC") ? false : item.mandatory,
                            mockup: item.mockup,
                            expired: item.expired,
                            deleted: item.deleted,
                            toHardDelete: item.toHardDelete,
                            hardDeleteDate: item.hardDeleteDate,
                            dateExpired: item.dateExpired,
                            contract: item.contract,
                            pdfmsg: item.pdfmsg,
                            data: item.data,
                            checked: false,
                            privacy: item.privacy
                        });
                    }
                    if ((!item.deleted || structureDocDeleted) && item.data) {
                        insertedDocs.push({
                            title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                            docId: item._id,
                            data: item.data,
                            checked: false,
                        });
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_3(doc);
        }
        var orderedDocList = [];
        if (docsTemplate && Array.isArray(docsTemplate)) {
            docsTemplate.forEach(function (orderEl) {
                var docListFiltered = docList.filter(function (el) {
                    return el.key === orderEl.key;
                });
                orderedDocList = orderedDocList.concat(docListFiltered);
            });
        }
        orderedDocList.sort(this.compareExpired);
        return orderedDocList;
    };
    /**
     * Utility: extracts only contracts from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.getDocsFromContractSection = function (section, keyTranslateTitle, lang, docsTemplate, subscriptionType, insertedDocs, structureDocDeleted) {
        if (structureDocDeleted === void 0) { structureDocDeleted = false; }
        var docList = [];
        var _loop_4 = function (doc) {
            if (doc.substring(0, 2) === 'EA' || doc === 'RF4') {
                return "continue";
            }
            var templateDoc = docsTemplate.find(function (el) {
                return el.key === doc;
            });
            if (section.documents[doc].length && templateDoc && !templateDoc.deleted) {
                section.documents[doc].forEach(function (item) {
                    if (item.contract) {
                        if (!item.deleted || structureDocDeleted) {
                            if (item.data &&
                                item.data.nomeSocietaEroganteInServizio &&
                                // (item.data.rilasciatoFirmatoDa ||
                                //   item.data.nomeDiRiferimento ||
                                //   item.data.nomeSocietaEroganteInServizio ||
                                //   item.data.nomeConduttore ||
                                //   item.data.ragioneSocialeCostruttore ||
                                //   item.data.daNome ||
                                //   item.data.riferimentoComuneASL ||
                                //   item.data.nomeAmministratoreDelCondominio ||
                                //   item.data.nomeIdentificativoDellaReteDiTeleriscaldamento ||
                                //   item.data.aFirmaDi ||
                                //   item.data.nomeFornitore) &&
                                typeof item.data.ragioneSocialeFornitore === "undefined") {
                                if (item.data.rilasciatoFirmatoDa) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.rilasciatoFirmatoDa;
                                }
                                else if (item.data.nomeDiRiferimento) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeDiRiferimento;
                                }
                                else if (item.data.nomeConduttore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeConduttore;
                                }
                                else if (item.data.ragioneSocialeCostruttore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.ragioneSocialeCostruttore;
                                }
                                else if (item.data.daNome) {
                                    item.data["ragioneSocialeFornitore"] = item.data.daNome;
                                }
                                else if (item.data.riferimentoComuneASL) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.riferimentoComuneASL;
                                }
                                else if (item.data.nomeAmministratoreDelCondominio) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeAmministratoreDelCondominio;
                                }
                                else if (item.data.nomeIdentificativoDellaReteDiTeleriscaldamento) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
                                }
                                else if (item.data.aFirmaDi) {
                                    item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
                                }
                                else if (item.data.nomeFornitore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeFornitore;
                                }
                                else {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeSocietaEroganteInServizio;
                                }
                            }
                            if (item.data && item.data.barCode) {
                                if (item.data.barCode.length > 6) {
                                    var docType = item.data.barCode.slice(-1);
                                    var docCode = item.data.barCode.substring(item.data.barCode.length - 7, item.data.barCode.length - 1);
                                    item.data["docCode"] = docCode + " " + docType;
                                }
                            }
                            if (item.data && item.cancellationRequestBy) {
                                item.data.cancellationRequestBy = item.cancellationRequestBy;
                                item.data.cancellationRequestDate = item.cancellationRequestDate;
                            }
                            docList.push({
                                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                                type: "doc",
                                docId: item._id,
                                key: doc,
                                mandatory: (subscriptionType === "FREE" || subscriptionType === "FREEBASIC") ? false : item.mandatory,
                                mockup: item.mockup,
                                expired: item.expired,
                                deleted: item.deleted,
                                toHardDelete: item.toHardDelete,
                                hardDeleteDate: item.hardDeleteDate,
                                dateExpired: item.dateExpired,
                                contract: item.contract,
                                pdfmsg: item.pdfmsg,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                                structureObjectId: item.structureObjectId !== "" ? item.structureObjectId : ""
                            });
                        }
                        // only contracts
                        var contractSection = doc.substr(0, 2) === "HA" ? true : false;
                        if ((!item.deleted || structureDocDeleted) && item.data && contractSection) {
                            insertedDocs.push({
                                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                                docId: item._id,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_4(doc);
        }
        docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Utility: extracts only privacy documents from one section of documentArchive
     * and show the documents into page
     * in getDocumentArchiveData()
     *
     * array of documents
     *
     * isOwnSection identifies documents that live exclusively in the "privacy" area's
     * own section (document.privacy): only those are pushed to insertedDocs here,
     * since documents aggregated from other areas are already pushed by getDocsFromSection()
     * when their origin area is processed, and pushing them again would duplicate entries
     * in the "send by email" attachment picker.
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.getDocsFromPrivacySection = function (section, keyTranslateTitle, lang, docsTemplate, subscriptionType, insertedDocs, structureDocDeleted, isOwnSection) {
        if (structureDocDeleted === void 0) { structureDocDeleted = false; }
        if (isOwnSection === void 0) { isOwnSection = false; }
        var docList = [];
        var _loop_5 = function (doc) {
            var templateDoc = docsTemplate.find(function (el) {
                return el.key === doc;
            });
            if (section.documents[doc].length && templateDoc && !templateDoc.deleted) {
                section.documents[doc].forEach(function (item) {
                    if (item.privacy) {
                        if (!item.deleted || structureDocDeleted) {
                            if (item.data &&
                                item.data.nomeSocietaEroganteInServizio &&
                                typeof item.data.ragioneSocialeFornitore === "undefined") {
                                if (item.data.rilasciatoFirmatoDa) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.rilasciatoFirmatoDa;
                                }
                                else if (item.data.nomeDiRiferimento) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeDiRiferimento;
                                }
                                else if (item.data.nomeConduttore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeConduttore;
                                }
                                else if (item.data.ragioneSocialeCostruttore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.ragioneSocialeCostruttore;
                                }
                                else if (item.data.daNome) {
                                    item.data["ragioneSocialeFornitore"] = item.data.daNome;
                                }
                                else if (item.data.riferimentoComuneASL) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.riferimentoComuneASL;
                                }
                                else if (item.data.nomeAmministratoreDelCondominio) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeAmministratoreDelCondominio;
                                }
                                else if (item.data.nomeIdentificativoDellaReteDiTeleriscaldamento) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeIdentificativoDellaReteDiTeleriscaldamento;
                                }
                                else if (item.data.aFirmaDi) {
                                    item.data["ragioneSocialeFornitore"] = item.data.aFirmaDi;
                                }
                                else if (item.data.nomeFornitore) {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeFornitore;
                                }
                                else {
                                    item.data["ragioneSocialeFornitore"] =
                                        item.data.nomeSocietaEroganteInServizio;
                                }
                            }
                            if (item.data && item.data.barCode) {
                                if (item.data.barCode.length > 6) {
                                    var docType = item.data.barCode.slice(-1);
                                    var docCode = item.data.barCode.substring(item.data.barCode.length - 7, item.data.barCode.length - 1);
                                    item.data["docCode"] = docCode + " " + docType;
                                }
                            }
                            docList.push({
                                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                                type: "doc",
                                docId: item._id,
                                key: doc,
                                mandatory: (subscriptionType === "FREE" || subscriptionType === "FREEBASIC") ? false : item.mandatory,
                                mockup: item.mockup,
                                expired: item.expired,
                                deleted: item.deleted,
                                toHardDelete: item.toHardDelete,
                                hardDeleteDate: item.hardDeleteDate,
                                dateExpired: item.dateExpired,
                                privacy: item.privacy,
                                pdfmsg: item.pdfmsg,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                                structureObjectId: item.structureObjectId !== "" ? item.structureObjectId : ""
                            });
                        }
                        if (isOwnSection && (!item.deleted || structureDocDeleted) && item.data) {
                            insertedDocs.push({
                                title: lang === "it" ? templateDoc.translation.it : templateDoc.translation.en,
                                docId: item._id,
                                data: item.data,
                                checked: false,
                                keyTranslateTitle: keyTranslateTitle,
                            });
                        }
                    }
                });
            }
        };
        for (var doc in section.documents) {
            _loop_5(doc);
        }
        docList.sort(this.compareExpired);
        return docList;
    };
    /**
     * Get documents of current property to show in view
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.getDocumentArchiveData = function (lang, documentTemplate, condoStructure, document, subscriptionType, insertedDocs, structureDocDeleted) {
        var _this = this;
        if (structureDocDeleted === void 0) { structureDocDeleted = false; }
        var gestAmmTivoDipendentiActive = false;
        var allDocs = [];
        documentTemplate.forEach(function (area) {
            if (!area.deleted) {
                if (area.title === "properties.documents.unitaImmobiliari") {
                    //
                    // UNITA' IMMOBILIARI
                    // I documenti sono raggruppati per unità immobiliare
                    if (condoStructure.unitaAbitativaCommerciale &&
                        Array.isArray(condoStructure.unitaAbitativaCommerciale) &&
                        condoStructure.unitaAbitativaCommerciale.length) {
                        var unitaImmobiliari_1 = [];
                        condoStructure.unitaAbitativaCommerciale.forEach(function (el) {
                            var contents = [];
                            if (area.content && Array.isArray(area.content)) {
                                area.content.forEach(function (uiEl) {
                                    var title = uiEl.title.replace("properties.documents.", "");
                                    if (typeof document[title] !== "undefined" && document[title].length) {
                                        var index = document[title].findIndex(function (item) {
                                            return el._id.toString() === item.structureObjectId.toString();
                                        });
                                        if (index > -1) {
                                            var elem = document[title][index];
                                            contents.push({
                                                title: lang === "it" ? uiEl.translation.it : uiEl.translation.en,
                                                active: true,
                                                keyTranslateTitle: uiEl.title,
                                                type: "title",
                                                docId: elem._id,
                                                structureId: elem.structureObjectId,
                                                content: _this.getDocsFromSection(elem, lang, uiEl.documents, subscriptionType, insertedDocs, (structureDocDeleted && !el.active) // Show deleted docs of deleted structures
                                                ),
                                            });
                                        }
                                    }
                                });
                            }
                            unitaImmobiliari_1.push({
                                active: el.active,
                                title: el.nome,
                                type: "title",
                                content: contents,
                                keyTranslateTitle: "properties.documents.unitaImmobiliari",
                            });
                        });
                        allDocs.push({
                            keyTranslateTitle: "properties.documents.unitaImmobiliari",
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            type: "title",
                            content: unitaImmobiliari_1,
                        });
                    }
                }
                else if (area.title === "properties.documents.contratti") {
                    //
                    // CONTRATTI
                    //
                    var contents = [];
                    var itemsContract_1 = [];
                    itemsContract_1.push({
                        title: "",
                        active: true,
                        type: "title",
                        docId: "",
                        structureId: "",
                        content: [],
                    });
                    if (typeof document.contratti !== "undefined" && document.contratti.documents) {
                        // document.contratti.forEach((elem: any) => {
                        var subDocs_1 = [];
                        var active_1 = true;
                        var title_2 = "";
                        var structureId_1 = 'undefined';
                        // if (elem.structureObjectId === "-1") {
                        //contratti generici
                        subDocs_1 = _this.getDocsFromContractSection(document.contratti, "properties.documents.contratti", lang, area.content[0].documents, subscriptionType, insertedDocs);
                        subDocs_1.forEach(function (subElem) {
                            title_2 = "";
                            structureId_1 = 'undefined';
                            if (subElem.key === "HA12") {
                                // Contratto fornitura energia elettrica bassa tensione
                                if (typeof subElem.structureObjectId !== "undefined") {
                                    var structure = condoStructure["fornituraBt"]
                                        ? condoStructure["fornituraBt"].find(function (item) {
                                            return item._id.toString() === subElem.structureObjectId.toString();
                                        })
                                        : undefined;
                                    if (structure) {
                                        // title = structure.nome;
                                        title_2 = structure.codicePod;
                                        structureId_1 = subElem.structureObjectId;
                                    }
                                }
                            }
                            if (subElem.key === "HA64") {
                                // Contratto fornitura energia elettrica bassa tensione
                                if (typeof subElem.structureObjectId !== "undefined") {
                                    var structure = condoStructure["fornituraMt"]
                                        ? condoStructure["fornituraMt"].find(function (item) {
                                            return item._id.toString() === subElem.structureObjectId.toString();
                                        })
                                        : undefined;
                                    if (structure) {
                                        // title = structure.nome;
                                        title_2 = structure.numeroContrattofornitur;
                                        structureId_1 = subElem.structureObjectId;
                                    }
                                }
                            }
                            var element = tslib_1.__assign({ structureTitle: title_2, structureId: structureId_1, active: active_1, documentId: '' }, subElem);
                            itemsContract_1[0].content.push(element);
                        });
                        // });
                    }
                    var subDocs_2 = [];
                    var active_2 = true;
                    var title_3 = "";
                    documentTemplate.forEach(function (contracts) {
                        if (contracts.title !== "properties.documents.contratti") {
                            contracts.content.forEach(function (subContracts) {
                                var titleSubContract = subContracts.title.replace("properties.documents.", "");
                                if (!subContracts.deleted) {
                                    if (subContracts.elementType === "object") {
                                        if (typeof document[titleSubContract] !== "undefined") {
                                            subDocs_2 = _this.getDocsFromContractSection(document[titleSubContract], subContracts.title, lang, subContracts.documents, subscriptionType, insertedDocs);
                                            subDocs_2.forEach(function (subElem) {
                                                var element = tslib_1.__assign({ structureTitle: "", structureId: "", active: true, documentId: "" }, subElem);
                                                itemsContract_1[0].content.push(element);
                                            });
                                        }
                                    }
                                    else if (subContracts.elementType === "array") {
                                        if (typeof document[titleSubContract] !== "undefined" && document[titleSubContract].length) {
                                            document[titleSubContract].forEach(function (elem) {
                                                var structureName = condoStructure[subContracts.structure]
                                                    ? condoStructure[subContracts.structure].find(function (item) {
                                                        return item._id.toString() === elem.structureObjectId.toString();
                                                    })
                                                    : undefined;
                                                if (structureName) {
                                                    // if (subContracts.structure === "estintori") {
                                                    //   title = "Estintori"
                                                    // } else 
                                                    if (subContracts.structure === "dipendenti") {
                                                        title_3 = structureName.nome + " " + structureName.cognome;
                                                    }
                                                    else {
                                                        title_3 = structureName.nome;
                                                    }
                                                }
                                                else {
                                                    title_3 = "";
                                                }
                                                active_2 = structureName ? structureName.active : false;
                                                subDocs_2 = _this.getDocsFromContractSection(elem, subContracts.title, lang, subContracts.documents, subscriptionType, insertedDocs, (structureDocDeleted && !active_2) // Show deleted docs of deleted structures
                                                );
                                                subDocs_2.forEach(function (subElem) {
                                                    var element = tslib_1.__assign({ structureTitle: title_3, structureId: elem.structureObjectId, active: active_2, documentId: elem._id }, subElem);
                                                    itemsContract_1[0].content.push(element);
                                                });
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    });
                    if (itemsContract_1[0].content.length) {
                        itemsContract_1[0].content.sort(_this.compareExpired);
                        contents.push({
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            keyTranslateTitle: "properties.documents.contratti",
                            type: "contract",
                            content: itemsContract_1,
                        });
                        allDocs.push({
                            keyTranslateTitle: "properties.documents.contratti",
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            type: "title",
                            content: contents,
                        });
                    }
                }
                else if (area.title === "properties.documents.Aprivacy") {
                    //
                    // PRIVACY
                    //
                    var contents = [];
                    var itemsPrivacy_1 = [];
                    itemsPrivacy_1.push({
                        title: "",
                        active: true,
                        type: "title",
                        docId: "",
                        structureId: "",
                        content: [],
                    });
                    if (typeof document.privacy !== "undefined" && document.privacy.documents) {
                        var ownSubDocs = _this.getDocsFromPrivacySection(document.privacy, "properties.documents.Aprivacy", lang, area.content[0].documents, subscriptionType, insertedDocs, false, true);
                        ownSubDocs.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: "undefined", active: true, documentId: "" }, subElem);
                            itemsPrivacy_1[0].content.push(element);
                        });
                    }
                    var privacySubDocs_1 = [];
                    var privacyActive_1 = true;
                    var privacyTitle_1 = "";
                    documentTemplate.forEach(function (privacyAreas) {
                        if (privacyAreas.title !== "properties.documents.Aprivacy") {
                            privacyAreas.content.forEach(function (subPrivacy) {
                                var titleSubPrivacy = subPrivacy.title.replace("properties.documents.", "");
                                if (!subPrivacy.deleted) {
                                    if (subPrivacy.elementType === "object") {
                                        if (typeof document[titleSubPrivacy] !== "undefined") {
                                            privacySubDocs_1 = _this.getDocsFromPrivacySection(document[titleSubPrivacy], subPrivacy.title, lang, subPrivacy.documents, subscriptionType, insertedDocs);
                                            privacySubDocs_1.forEach(function (subElem) {
                                                var element = tslib_1.__assign({ structureTitle: "", structureId: "", active: true, documentId: "" }, subElem);
                                                itemsPrivacy_1[0].content.push(element);
                                            });
                                        }
                                    }
                                    else if (subPrivacy.elementType === "array") {
                                        if (typeof document[titleSubPrivacy] !== "undefined" && document[titleSubPrivacy].length) {
                                            document[titleSubPrivacy].forEach(function (elem) {
                                                var structureName = condoStructure[subPrivacy.structure]
                                                    ? condoStructure[subPrivacy.structure].find(function (item) {
                                                        return item._id.toString() === elem.structureObjectId.toString();
                                                    })
                                                    : undefined;
                                                if (structureName) {
                                                    if (subPrivacy.structure === "dipendenti") {
                                                        privacyTitle_1 = structureName.nome + " " + structureName.cognome;
                                                    }
                                                    else {
                                                        privacyTitle_1 = structureName.nome;
                                                    }
                                                }
                                                else {
                                                    privacyTitle_1 = "";
                                                }
                                                privacyActive_1 = structureName ? structureName.active : false;
                                                privacySubDocs_1 = _this.getDocsFromPrivacySection(elem, subPrivacy.title, lang, subPrivacy.documents, subscriptionType, insertedDocs, (structureDocDeleted && !privacyActive_1) // Show deleted docs of deleted structures
                                                );
                                                privacySubDocs_1.forEach(function (subElem) {
                                                    var element = tslib_1.__assign({ structureTitle: privacyTitle_1, structureId: elem.structureObjectId, active: privacyActive_1, documentId: elem._id }, subElem);
                                                    itemsPrivacy_1[0].content.push(element);
                                                });
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    });
                    if (itemsPrivacy_1[0].content.length) {
                        itemsPrivacy_1[0].content.sort(_this.compareExpired);
                        contents.push({
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            keyTranslateTitle: "properties.documents.Aprivacy",
                            type: "contract",
                            content: itemsPrivacy_1,
                        });
                        allDocs.push({
                            keyTranslateTitle: "properties.documents.Aprivacy",
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            type: "title",
                            content: contents,
                        });
                    }
                }
                else if (area.title ===
                    "properties.documents.attivitaSottopostePrevenzioneIncendi") {
                    if (typeof document.vvFdefinitivo !== "undefined" &&
                        document.vvFdefinitivo.length) {
                        var vvF = [];
                        var contents = [];
                        var items = document.vvFdefinitivo.map(function (elem) {
                            if (elem.structureObjectId === "-1") {
                                //doc  generici
                                return {
                                    title: lang === "it" ? "Edificio uso terziario " + elem.structureObjectName : "Tertiary use building " + elem.structureObjectName,
                                    keyTranslateTitle: lang === "it" ? "Edificio uso terziario " + elem.structureObjectName : "Tertiary use building " + elem.structureObjectName,
                                    active: true,
                                    type: "title",
                                    docId: elem._id,
                                    structureId: elem.structureObjectId,
                                    content: _this.getDocsFromSection(elem, lang, area.content[0].documents, subscriptionType, insertedDocs),
                                    structureObjectType: "-1",
                                };
                            }
                            else {
                                var structureName = condoStructure[elem.structureObjectType]
                                    ? condoStructure[elem.structureObjectType].find(function (item) {
                                        return item._id.toString() === elem.structureObjectId.toString();
                                    })
                                    : undefined;
                                var content = _this.getDocsFromSection(elem, lang, area.content[0].documents, subscriptionType, insertedDocs, (structureDocDeleted && !structureName.active) // Show deleted docs of deleted structures
                                );
                                if (content.length) {
                                    return {
                                        title: elem.structureObjectName,
                                        keyTranslateTitle: elem.structureObjectName,
                                        active: structureName ? structureName.active : false,
                                        type: "title",
                                        docId: elem._id,
                                        structureId: elem.structureObjectId,
                                        content: content,
                                        structureObjectType: elem.structureObjectType,
                                    };
                                }
                                else {
                                    return [];
                                }
                            }
                        });
                        var itemsOrdered_1 = [];
                        // fabbricatoAbitativo 77
                        items.forEach(function (elem) {
                            if (elem.structureObjectType === "fabbricatoAbitativo") {
                                itemsOrdered_1.push(elem);
                            }
                        });
                        // compartimentoBox 75
                        items.forEach(function (elem) {
                            if (elem.structureObjectType === "compartimentoBox") {
                                itemsOrdered_1.push(elem);
                            }
                        });
                        // centraleTermica 74
                        items.forEach(function (elem) {
                            if (elem.structureObjectType === "centraleTermica") {
                                itemsOrdered_1.push(elem);
                            }
                        });
                        // gruppoElettrogeno 49
                        items.forEach(function (elem) {
                            if (elem.structureObjectType === "gruppoElettrogeno") {
                                itemsOrdered_1.push(elem);
                            }
                        });
                        // attivitavvf 50
                        items.forEach(function (elem) {
                            if (elem.structureObjectType === "attivitavvf") {
                                itemsOrdered_1.push(elem);
                            }
                        });
                        // varie
                        items.forEach(function (elem) {
                            if (elem.structureObjectType === "-1") {
                                itemsOrdered_1.push(elem);
                            }
                        });
                        if (itemsOrdered_1.length) {
                            contents.push({
                                title: lang === "it" ? area.translation.it : area.translation.en,
                                keyTranslateTitle: "properties.documents.vvFdefinitivo",
                                type: "title",
                                content: itemsOrdered_1,
                            });
                        }
                        if (contents.length) {
                            allDocs.push({
                                keyTranslateTitle: "properties.documents.attivitaSottopostePrevenzioneIncendi",
                                title: lang === "it" ? area.translation.it : area.translation.en,
                                type: "title",
                                content: contents,
                            });
                        }
                    }
                }
                else {
                    var contents_1 = [];
                    area.content.forEach(function (subArea) {
                        if (!subArea.deleted) {
                            var title_4 = subArea.title.replace("properties.documents.", "");
                            if (subArea.elementType === "object") {
                                if (typeof document[title_4] !== "undefined") {
                                    var items = _this.getDocsFromSection(document[title_4], lang, subArea.documents, subscriptionType, insertedDocs);
                                    if (items && Array.isArray(items) && items.length) {
                                        if (title_4 === "gestAmmTivoGestioneDipend") {
                                            if (!gestAmmTivoDipendentiActive) {
                                                if (items && Array.isArray(items)) {
                                                    items.forEach(function (item) {
                                                        item.mandatory = false;
                                                    });
                                                }
                                                contents_1.push({
                                                    active: false,
                                                    title: lang === "it"
                                                        ? subArea.translation.it
                                                        : subArea.translation.en,
                                                    keyTranslateTitle: subArea.title,
                                                    type: "doc",
                                                    content: items,
                                                });
                                            }
                                            else {
                                                contents_1.push({
                                                    active: true,
                                                    title: lang === "it"
                                                        ? subArea.translation.it
                                                        : subArea.translation.en,
                                                    keyTranslateTitle: subArea.title,
                                                    type: "doc",
                                                    content: items,
                                                });
                                            }
                                        }
                                        else if (title_4 === "gestAmmTivoCauseLegali" ||
                                            title_4 === "edileinterventiSuccessivi" ||
                                            title_4 === "DpraticheEdilizie") {
                                            var items2_1 = [];
                                            items.forEach(function (elem) {
                                                if (typeof elem.data !== "undefined") {
                                                    var index = items2_1.findIndex(function (subElem) {
                                                        return (subElem.title ===
                                                            elem.data.nomeArchiviazioneIntervento);
                                                    });
                                                    if (index > -1) {
                                                        items2_1[index].content.push(elem);
                                                    }
                                                    else {
                                                        items2_1.push({
                                                            title: elem.data.nomeArchiviazioneIntervento,
                                                            active: true,
                                                            type: "title",
                                                            docId: undefined,
                                                            structureId: undefined,
                                                            content: [elem],
                                                        });
                                                    }
                                                }
                                            });
                                            if (items2_1.length) {
                                                contents_1.push({
                                                    title: lang === "it"
                                                        ? subArea.translation.it
                                                        : subArea.translation.en,
                                                    keyTranslateTitle: subArea.title,
                                                    type: "title",
                                                    content: items2_1,
                                                });
                                            }
                                        }
                                        else if (title_4 === "gestAmmTivoValutFornitori") {
                                            var items2_2 = [];
                                            items.forEach(function (elem) {
                                                if (typeof elem.data !== "undefined") {
                                                    var index = items2_2.findIndex(function (subElem) {
                                                        return subElem.title === elem.data.nomeFornitore;
                                                    });
                                                    if (index > -1) {
                                                        items2_2[index].content.push(elem);
                                                    }
                                                    else {
                                                        items2_2.push({
                                                            title: elem.data.nomeFornitore,
                                                            active: true,
                                                            type: "title",
                                                            docId: undefined,
                                                            structureId: undefined,
                                                            content: [elem],
                                                        });
                                                    }
                                                }
                                            });
                                            if (items2_2.length) {
                                                contents_1.push({
                                                    title: lang === "it"
                                                        ? subArea.translation.it
                                                        : subArea.translation.en,
                                                    keyTranslateTitle: subArea.title,
                                                    type: "title",
                                                    content: items2_2,
                                                });
                                            }
                                        }
                                        else if (title_4 === "locazioneContrdiLocazione") {
                                            var items2_3 = [];
                                            items.forEach(function (elem) {
                                                if (typeof elem.data !== "undefined") {
                                                    var index = items2_3.findIndex(function (subElem) {
                                                        return subElem.title === elem.data.nomeConduttore;
                                                    });
                                                    if (index > -1) {
                                                        items2_3[index].content.push(elem);
                                                    }
                                                    else {
                                                        items2_3.push({
                                                            title: elem.data.nomeConduttore,
                                                            active: true,
                                                            type: "title",
                                                            docId: undefined,
                                                            structureId: undefined,
                                                            content: [elem],
                                                        });
                                                    }
                                                }
                                                else {
                                                    items2_3.push({
                                                        title: "",
                                                        active: true,
                                                        type: "title",
                                                        docId: undefined,
                                                        structureId: undefined,
                                                        content: [elem],
                                                    });
                                                }
                                            });
                                            if (items2_3.length) {
                                                contents_1.push({
                                                    title: lang === "it"
                                                        ? subArea.translation.it
                                                        : subArea.translation.en,
                                                    keyTranslateTitle: subArea.title,
                                                    type: "title",
                                                    content: items2_3,
                                                });
                                            }
                                        }
                                        else {
                                            contents_1.push({
                                                title: lang === "it"
                                                    ? subArea.translation.it
                                                    : subArea.translation.en,
                                                keyTranslateTitle: subArea.title,
                                                type: "doc",
                                                content: items,
                                            });
                                        }
                                    }
                                }
                            }
                            else if (subArea.elementType === "array") {
                                if (typeof document[title_4] !== "undefined" && document[title_4].length) {
                                    var items = document[title_4].map(function (elem) {
                                        var structureName = condoStructure[subArea.structure]
                                            ? condoStructure[subArea.structure].find(function (item) {
                                                return item._id.toString() === elem.structureObjectId.toString();
                                            })
                                            : undefined;
                                        if (title_4 === "gestAmmTivoDipendenti" &&
                                            subArea.structure === "dipendenti") {
                                            if (structureName && structureName.active) {
                                                gestAmmTivoDipendentiActive = true;
                                            }
                                        }
                                        var structureTitle = "";
                                        if (structureName) {
                                            structureTitle = structureName.nome;
                                            // if (subArea.structure === "estintori") {
                                            //   structureTitle = "Estintori"
                                            // }
                                            if (subArea.structure === "dipendenti") {
                                                structureTitle = structureName.nome + " " + structureName.cognome;
                                            }
                                        }
                                        var items = _this.getDocsFromSection(elem, lang, subArea.documents, subscriptionType, insertedDocs, (structureDocDeleted && !(structureName ? structureName.active : false)) // Show deleted docs of deleted structures
                                        );
                                        return {
                                            title: structureTitle,
                                            active: structureName ? structureName.active : false,
                                            type: "title",
                                            docId: elem._id,
                                            structureId: elem.structureObjectId,
                                            content: items,
                                        };
                                    });
                                    if (items.length) {
                                        contents_1.push({
                                            title: lang === "it"
                                                ? subArea.translation.it
                                                : subArea.translation.en,
                                            keyTranslateTitle: subArea.title,
                                            type: "title",
                                            content: items,
                                        });
                                    }
                                }
                            }
                        }
                    });
                    if (contents_1.length > 0) {
                        allDocs.push({
                            keyTranslateTitle: area.title,
                            title: area.translation.it,
                            type: "title",
                            content: contents_1,
                        });
                    }
                }
            }
        });
        return allDocs;
    };
    /**
     * Get documents of current FREE property to show in view
     *
     * @since 1.0.0
     */
    DocumentTypeStructure.prototype.getDocumentArchiveDataFree = function (lang, documentTemplate, document, subscriptionType, insertedDocs) {
        var _this = this;
        var gestAmmTivoDipendentiActive = true;
        var allDocs = [];
        documentTemplate.forEach(function (area) {
            if (!area.deleted) {
                if (area.title === "properties.documents.contratti") {
                    //
                    // CONTRATTI
                    //
                    var contents = [];
                    var itemsContract_2 = [];
                    itemsContract_2.push({
                        title: "",
                        active: true,
                        type: "title",
                        docId: "",
                        structureId: "",
                        content: [],
                    });
                    if (typeof document.contratti !== "undefined" &&
                        document.contratti.documents) {
                        // document.contratti.forEach((elem: any) => {
                        var subDocs_3 = [];
                        var active_3 = true;
                        var title_5 = "";
                        // if (elem.structureObjectId === "-1") {
                        //contratti generici
                        subDocs_3 = _this.getDocsFromContractSection(document.contratti, "properties.documents.contratti", lang, area.content[0].documents, subscriptionType, insertedDocs);
                        title_5 = "";
                        subDocs_3.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: title_5, structureId: '', active: active_3, documentId: '' }, subElem);
                            itemsContract_2[0].content.push(element);
                        });
                    }
                    var subDocs_4 = [];
                    // let active = true;
                    // let title = "";
                    documentTemplate.forEach(function (contracts) {
                        if (contracts.title !== "properties.documents.contratti") {
                            contracts.content.forEach(function (subContracts) {
                                var titleSubContract = subContracts.title.replace("properties.documents.", "");
                                if (!subContracts.deleted) {
                                    if (subContracts.elementType === "object" || subContracts.elementType === "array") {
                                        if (typeof document[titleSubContract] !== "undefined") {
                                            subDocs_4 = _this.getDocsFromContractSection(document[titleSubContract], subContracts.title, lang, subContracts.documents, subscriptionType, insertedDocs);
                                            subDocs_4.forEach(function (subElem) {
                                                var element = tslib_1.__assign({ structureTitle: "", structureId: "", active: true, documentId: "" }, subElem);
                                                // itemsContract[0].content.push(element);
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    });
                    if (itemsContract_2[0].content.length) {
                        itemsContract_2[0].content.sort(_this.compareExpired);
                        contents.push({
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            keyTranslateTitle: "properties.documents.contratti",
                            type: "contract",
                            content: itemsContract_2,
                        });
                        allDocs.push({
                            keyTranslateTitle: "properties.documents.contratti",
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            type: "title",
                            content: contents,
                        });
                    }
                }
                else if (area.title === "properties.documents.Aprivacy") {
                    //
                    // PRIVACY
                    //
                    var contents = [];
                    var itemsPrivacy_2 = [];
                    itemsPrivacy_2.push({
                        title: "",
                        active: true,
                        type: "title",
                        docId: "",
                        structureId: "",
                        content: [],
                    });
                    if (typeof document.privacy !== "undefined" &&
                        document.privacy.documents) {
                        var ownSubDocs = _this.getDocsFromPrivacySection(document.privacy, "properties.documents.Aprivacy", lang, area.content[0].documents, subscriptionType, insertedDocs, false, true);
                        ownSubDocs.forEach(function (subElem) {
                            var element = tslib_1.__assign({ structureTitle: "", structureId: '', active: true, documentId: '' }, subElem);
                            itemsPrivacy_2[0].content.push(element);
                        });
                    }
                    var privacySubDocs_2 = [];
                    documentTemplate.forEach(function (privacyAreas) {
                        if (privacyAreas.title !== "properties.documents.Aprivacy") {
                            privacyAreas.content.forEach(function (subPrivacy) {
                                var titleSubPrivacy = subPrivacy.title.replace("properties.documents.", "");
                                if (!subPrivacy.deleted) {
                                    if (subPrivacy.elementType === "object" || subPrivacy.elementType === "array") {
                                        if (typeof document[titleSubPrivacy] !== "undefined") {
                                            privacySubDocs_2 = _this.getDocsFromPrivacySection(document[titleSubPrivacy], subPrivacy.title, lang, subPrivacy.documents, subscriptionType, insertedDocs);
                                            privacySubDocs_2.forEach(function (subElem) {
                                                var element = tslib_1.__assign({ structureTitle: "", structureId: "", active: true, documentId: "" }, subElem);
                                                // itemsPrivacy[0].content.push(element);
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    });
                    if (itemsPrivacy_2[0].content.length) {
                        itemsPrivacy_2[0].content.sort(_this.compareExpired);
                        contents.push({
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            keyTranslateTitle: "properties.documents.Aprivacy",
                            type: "contract",
                            content: itemsPrivacy_2,
                        });
                        allDocs.push({
                            keyTranslateTitle: "properties.documents.Aprivacy",
                            title: lang === "it" ? area.translation.it : area.translation.en,
                            type: "title",
                            content: contents,
                        });
                    }
                }
                else if (area.title ===
                    "properties.documents.attivitaSottopostePrevenzioneIncendi") {
                    if (typeof document.vvFdefinitivo !== "undefined") {
                        var vvF = [];
                        var contents = [];
                        var items = _this.getDocsFromSection(document['vvFdefinitivo'], lang, area.content[0].documents, subscriptionType, insertedDocs);
                        var itemsOrdered_2 = [];
                        items.forEach(function (elem) {
                            itemsOrdered_2.push(elem);
                        });
                        if (itemsOrdered_2.length) {
                            contents.push({
                                title: lang === "it" ? area.translation.it : area.translation.en,
                                keyTranslateTitle: "properties.documents.vvFdefinitivo",
                                type: "doc",
                                content: itemsOrdered_2,
                            });
                        }
                        if (contents.length) {
                            allDocs.push({
                                keyTranslateTitle: "properties.documents.attivitaSottopostePrevenzioneIncendi",
                                title: lang === "it" ? area.translation.it : area.translation.en,
                                type: "title",
                                content: contents,
                            });
                        }
                    }
                }
                else {
                    var contents_2 = [];
                    area.content.forEach(function (subArea) {
                        if (!subArea.deleted) {
                            var title = subArea.title.replace("properties.documents.", "");
                            if (typeof document[title] !== "undefined") {
                                var items = _this.getDocsFromSection(document[title], lang, subArea.documents, subscriptionType, insertedDocs);
                                if (title === "gestAmmTivoGestioneDipend") {
                                    if (!gestAmmTivoDipendentiActive) {
                                        if (items && Array.isArray(items)) {
                                            items.forEach(function (item) {
                                                item.mandatory = false;
                                            });
                                        }
                                        contents_2.push({
                                            active: false,
                                            title: lang === "it"
                                                ? subArea.translation.it
                                                : subArea.translation.en,
                                            keyTranslateTitle: subArea.title,
                                            type: "doc",
                                            content: items,
                                        });
                                    }
                                    else {
                                        contents_2.push({
                                            active: true,
                                            title: lang === "it"
                                                ? subArea.translation.it
                                                : subArea.translation.en,
                                            keyTranslateTitle: subArea.title,
                                            type: "doc",
                                            content: items,
                                        });
                                    }
                                }
                                else if (title === "gestAmmTivoCauseLegali" ||
                                    title === "edileinterventiSuccessivi" ||
                                    title === "DpraticheEdilizie") {
                                    var items2_4 = [];
                                    items.forEach(function (elem) {
                                        if (typeof elem.data !== "undefined") {
                                            var index = items2_4.findIndex(function (subElem) {
                                                return (subElem.title ===
                                                    elem.data.nomeArchiviazioneIntervento);
                                            });
                                            if (index > -1) {
                                                items2_4[index].content.push(elem);
                                            }
                                            else {
                                                items2_4.push({
                                                    title: elem.data.nomeArchiviazioneIntervento,
                                                    active: true,
                                                    type: "title",
                                                    docId: undefined,
                                                    structureId: "",
                                                    content: [elem],
                                                });
                                            }
                                        }
                                    });
                                    if (items2_4.length) {
                                        contents_2.push({
                                            title: lang === "it"
                                                ? subArea.translation.it
                                                : subArea.translation.en,
                                            keyTranslateTitle: subArea.title,
                                            type: "title",
                                            content: items2_4,
                                        });
                                    }
                                }
                                else if (title === "gestAmmTivoValutFornitori") {
                                    var items2_5 = [];
                                    items.forEach(function (elem) {
                                        if (typeof elem.data !== "undefined") {
                                            var index = items2_5.findIndex(function (subElem) {
                                                return subElem.title === elem.data.nomeFornitore;
                                            });
                                            if (index > -1) {
                                                items2_5[index].content.push(elem);
                                            }
                                            else {
                                                items2_5.push({
                                                    title: elem.data.nomeFornitore,
                                                    active: true,
                                                    type: "title",
                                                    docId: undefined,
                                                    structureId: "",
                                                    content: [elem],
                                                });
                                            }
                                        }
                                    });
                                    if (items2_5.length) {
                                        contents_2.push({
                                            title: lang === "it"
                                                ? subArea.translation.it
                                                : subArea.translation.en,
                                            keyTranslateTitle: subArea.title,
                                            type: "title",
                                            content: items2_5,
                                        });
                                    }
                                }
                                else if (title === "locazioneContrdiLocazione") {
                                    var items2_6 = [];
                                    items.forEach(function (elem) {
                                        if (typeof elem.data !== "undefined") {
                                            var index = items2_6.findIndex(function (subElem) {
                                                return subElem.title === elem.data.nomeConduttore;
                                            });
                                            if (index > -1) {
                                                items2_6[index].content.push(elem);
                                            }
                                            else {
                                                items2_6.push({
                                                    title: elem.data.nomeConduttore,
                                                    active: true,
                                                    type: "title",
                                                    docId: undefined,
                                                    structureId: "",
                                                    content: [elem],
                                                });
                                            }
                                        }
                                    });
                                    if (items2_6.length) {
                                        contents_2.push({
                                            title: lang === "it"
                                                ? subArea.translation.it
                                                : subArea.translation.en,
                                            keyTranslateTitle: subArea.title,
                                            type: "title",
                                            content: items2_6,
                                        });
                                    }
                                }
                                else {
                                    contents_2.push({
                                        title: lang === "it"
                                            ? subArea.translation.it
                                            : subArea.translation.en,
                                        keyTranslateTitle: subArea.title,
                                        type: "doc",
                                        content: items,
                                    });
                                }
                            }
                        }
                    });
                    if (contents_2.length > 0) {
                        allDocs.push({
                            keyTranslateTitle: area.title,
                            title: area.translation.it,
                            type: "title",
                            content: contents_2,
                        });
                    }
                }
            }
        });
        return allDocs;
    };
    return DocumentTypeStructure;
}());
export default DocumentTypeStructure;
